/* eslint-disable camelcase */
import { Fragment, useEffect, useState } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ProfileAvatarDropdown } from "./ProfileAvatarDropdown";
import { UserRoles } from "../../constants";
import { HeaderLinksText } from "./Constants";
import { Typography } from "src/latest/src/components";

type Props = {
    handleSwitchRole: (role: string) => void;
    handleNav: (path: string) => void;
};

export const AuthenticatedUserHeaderContent = ({
    handleSwitchRole,
    handleNav,
}: Props) => {
    const loggedInUser = useSelector(
        (state: any) => state?.authentication?.loggedInUser
    );
    const { user_type } = loggedInUser;
    const [activeType, setActiveType] = useState("");

    const userTypes = [
        ...(user_type?.includes(UserRoles.THERAPIST) ? [UserRoles.THERAPIST] : []),
        ...(user_type?.includes(UserRoles.SCHEDULER) ? [UserRoles.SCHEDULER] : []),
        ...(user_type?.includes(UserRoles.PRACTICE_ADMIN) &&
        !user_type?.includes(UserRoles.SCHEDULER)
            ? [UserRoles.SCHEDULER]
            : []),
        ...(user_type?.includes(UserRoles.PRACTICE_ADMIN) ? [UserRoles.PRACTICE_ADMIN] : []),
        ...(user_type?.includes(UserRoles.TENANT_SUPER_ADMIN) ? [UserRoles.TENANT_SUPER_ADMIN] : []),
    ];

    const getActiveTab = (currentActivePath: string) => {
        if (!currentActivePath) {
            setActiveType("");

            return;
        }
    
        switch (true) {
            case currentActivePath.includes("/therapy/scheduler"):
                setActiveType(UserRoles.SCHEDULER);
                break;
            case currentActivePath.includes("/practice-admin"):
                setActiveType(UserRoles.PRACTICE_ADMIN);
                break;
            case currentActivePath.includes("/therapy/therapist"):
                setActiveType(UserRoles.THERAPIST);
                break;
            case currentActivePath.includes("/super-admin"):
                setActiveType(UserRoles.TENANT_SUPER_ADMIN);
                break;
            default:
                setActiveType("");
        }
    };
    
    useEffect(() => {
        getActiveTab(window.location.pathname);
    }, [window.location.pathname]);

    return (
        <>
            <Fragment>
            {userTypes.length > 0 && (
                <Navbar.Toggle aria-controls="questionnaire-header">
                    {[...Array(3)].map((_, i) => (
                        <span key={i} className="menu-stripped" />
                    ))}
                </Navbar.Toggle>
                )}
                <Navbar.Collapse id="questionnaire-header">
                    <Nav className="ms-auto">
                        <div className="user-type-wrapper">
                            {(userTypes || []).length > 0 &&
                                userTypes?.map((type: string, i: number) => (
                                    <Typography
                                        key={i}
                                        onClick={() => {
                                            handleSwitchRole(
                                                type?.toLowerCase()
                                            );
                                            setActiveType(type);
                                        }}
                                        className={`navigation-links ${
                                            type === activeType ? "active" : ""
                                        }`}
                                        weight="semi-bold"
                                        color={`${
                                            type === activeType
                                                ? "color-39"
                                                : "color-38"
                                        }`}
                                        variant="size-16"
                                    >
                                        {HeaderLinksText[type]}
                                    </Typography>
                                ))}
                        </div>

                        <ProfileAvatarDropdown
                            onLogout={() => handleNav("/logout")}
                         />
                    </Nav>
                </Navbar.Collapse>
            </Fragment>
        </>
    );
};